import type { ReactNode } from 'react';
import { hostVetrina } from '@/app/marca';
import { Insegna } from './Insegna';
import s from './vetrina.module.css';

/**
 * La vetrina pubblica: l'insegna in cima, e sotto l'app dentro un tablet.
 *
 * Il problema che risolve e' di lettura, non di navigazione. Cio' che parla di
 * noi viveva dentro le due shell, subito sotto la testata: stesso fondo,
 * stessa larghezza, stessa aria — lo si prendeva per una terza fila di menu
 * dell'app, e un valutatore finiva per attribuire al prodotto una barra che e'
 * nostra.
 *
 * Qui l'insegna sta sopra tutto ed e' fuori dall'app, e l'app scende dentro
 * una cornice che si vede: bordo, angoli, un piano attorno. Il confine non e'
 * piu' una sfumatura di grigio da interpretare, e la demo si presenta come si
 * presenta il prodotto a un cliente — su un tablet appeso al muro.
 *
 * Il banco di prova — comporre l'impianto, scegliere l'area da cui entrarci —
 * non e' piu' qui: sta sul sito (`Insegna` ci riporta). Qui c'e' l'app, aperta
 * sull'impianto che il link portava nella query.
 *
 * 🚨 Solo su un host vetrina: altrove restituisce i figli intatti, senza
 * aggiungere un solo nodo. Su un host installatore l'app e' l'impianto di
 * qualcuno, non una dimostrazione, e incorniciarla sarebbe una bugia.
 *
 * Sta FUORI dal cancello di accesso, cosi' la cornice non sparisce durante un
 * caricamento.
 */
export function Vetrina({ children }: { children: ReactNode }) {
  if (typeof window === 'undefined' || !hostVetrina(window.location.hostname)) return <>{children}</>;

  return (
    <div className={s.vetrina}>
      <Insegna />
      <div className={s.palco}>
        <div className={s.tavoletta}>
          <span className={s.fotocamera} aria-hidden />
          {/* Lo schermo ritaglia; il figlio scorre. Sono due elementi perche'
              il ritaglio deve restare sull'elemento con gli angoli tondi e lo
              scorrimento su quello che le testate appiccicose osservano. */}
          <div className={s.schermo}>
            <div className={s.scorrimento}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
